import * as React from "react";

import classnames from "classnames";

import { UpdateValueFunc } from "../actions/UpdateValueActions";
import { SchemaType } from "../model/VariableSchema";

import { ArrayEditor } from "./ArrayEditor";
import { BooleanEditor } from "./BooleanEditor";
import { NumberEditor } from "./NumberEditor";
import { SecretEditor } from "./SecretEditor";
import { StringEditor } from "./StringEditor";

export const EnvironmentVariableEditor: React.FunctionComponent<EnvironmentVariableEditorProps> = (props) => {
    const updateSingleValue = (newValue: string | boolean | string[], environmentId: number) => {
        if (((!props.value) && newValue)
            || ((!props.value) && typeof newValue === 'boolean')
            || (props.value && newValue !== props.value))
        {
            props.updateValue(props.schemaId, environmentId, newValue, props.variableVersion || 0);
        }
    };

    const getEditorForIndividualValue = (schemaType: SchemaType | undefined, environmentId: number, value: string | boolean | string[] | undefined | null) => {
        switch (schemaType) {
            case SchemaType.String:
                return (
                    <StringEditor
                        value={value as string}
                        updateSingleValue={updateSingleValue}
                        environmentId={environmentId}
                    >
                    </StringEditor>);
            case SchemaType.Secret:
                return (
                    <SecretEditor
                        value={value as string}
                        updateSingleValue={updateSingleValue}
                        environmentId={environmentId}
                    />);
            case SchemaType.Number:
                return (
                    <NumberEditor
                        value={value as string}
                        updateSingleValue={updateSingleValue}
                        environmentId={environmentId}
                    />
                );
            case SchemaType.Boolean:
                return (
                    <BooleanEditor
                        value={value as boolean}
                        updateSingleValue={updateSingleValue}
                        environmentId={environmentId}
                    />);
            case SchemaType.Array:
                return (
                    <ArrayEditor
                        value={value as string[]}
                        updateSingleValue={updateSingleValue}
                        environmentId={environmentId}
                    />);
            default:
                throw Error(`Unrecognized variable type: ${schemaType}`);
        }
    };

    const highLight =
        props.value && props.filterText && (typeof props.value === "string") &&
        (props.value.toLowerCase().indexOf(props.filterText.toLowerCase()) !== -1);
    return (
        <div className="environmentVariableEditor" style={{ width: '100%' }}>
            <div
                id={`variable-${props.schemaId}-for-env-${props.environmentId}`}
                className={classnames("environmentVariableValue", { "yellow-box-shadow": highLight as any })}
            >
                {getEditorForIndividualValue(props.schemaType, props.environmentId, props.value)}
            </div>
        </div>
    );
};

export interface EnvironmentVariableEditorProps {
    environmentId: number;
    schemaId: number | undefined | null;
    schemaType: SchemaType | undefined;
    value: string | boolean | string[] | null | undefined;
    variableVersion: number | null;
    updateValue: UpdateValueFunc;
    filterText: string;
}

export interface EditorProps<T> {
    value: T;
    updateSingleValue: (newValue: T, environmentId: number) => void;
    environmentId: number;
}

export interface EditorState<T> {
    value: T;
}
